<template>
    <div class="rbt-left-panel popup-dashboardleft-section">
        <div class="rbt-default-sidebar">
            <div class="inner">
                <div class="content-item-content">
                    <div class="rbt-default-sidebar-wrapper">
                        <nav class="mainmenu-nav">
                            <div class="rbt-sm-separator"></div>
                            <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                <li>
                                    <a href="javascript:void(0)" @click="acao('Chat')" :class="{active:subIsActive('Chat')}">
                                        <img src="assets/images/generator-icon/text.png"
                                             alt="AI Generator"><span>Parecer Inteligente</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" @click="acao('Artefato')" :class="{active:subIsActive('Artefato')}">
                                        <img src="assets/images/generator-icon/leis.png"
                                             alt="AI Generator"><span>Artefatos</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" @click="acao('Research')" :class="{active:subIsActive('Research')}">
                                        <img src="assets/images/generator-icon/search.png"
                                             alt="AI Generator"><span>SollAi Research</span>
                                    </a>
                                </li>
                            </ul>

                        </nav>

                        <div class="rbt-sm-separator"></div>
                        <p class="mb-0 txt-p txt-size-14" v-if="msgManutencao">
                            Olá! Aqui é Sollai, a 1ª IA especialista em licitações e contratos do Brasil. Estou passando por uma atualização e treinamento em minha base, o que pode causar algumas oscilações em meu desempenho. Agradeço pela sua compreensão e estou trabalhando para retornar ao meu melhor estado o mais breve possível.
                        </p>
                    </div>
                </div>
            </div>

            <div class="subscription-box">
                <div class="inner">
                    <template v-if="utilizacoes">
                        <p class="px-3 mt-3 mb-1">
                            Total Pareceres: <span class="text-muted">{{utilizacoes.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoes.qtdLiberados}}</span>
                        </p>
                        <div class="px-3">
                            <div class="progress mt-1 custom-progress">
                                <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentual+'%'}"
                                     aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentual}}</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="utilizacoesArtefato">
                        <p class="px-3 mt-3 mb-1">
                            Total Artefatos: <span class="text-muted">{{utilizacoesArtefato.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoesArtefato.qtdLiberados}}</span>
                        </p>
                        <div class="px-3">
                            <div class="progress mt-1 custom-progress">
                                <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentualArtefato+'%'}"
                                     aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentualArtefato}}</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="utilizacoesResearch">
                        <p class="px-3 mt-3 mb-1">
                            Total Researchs: <span class="text-muted">{{utilizacoesResearch.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoesResearch.qtdLiberados}}</span>
                        </p>
                        <div class="px-3">
                            <div class="progress mt-1 custom-progress">
                                <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentualResearch+'%'}"
                                     aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentualResearch}}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <p class="subscription-copyright copyright-text text-center b4  small-text">
                © 2024 <a  target="_blank" :href="urlSite">
                    SollAi |
                    Inteligencia
                    Artificial
                </a>.
            </p>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, msgManutencao } from '@/config/global'
    import axios from 'axios'
    import { urlSite } from '@/config/global'
   
    export default {
        name: 'Navegacao',
        components: {},
        props: {
            acao: Function,
            nmComponente: String,
            reload: Boolean,
        },
        computed: {
            user() {
                return this.$store.state.user
            },
                        
            primeiroNome() {
                if (this.user && this.user.usuario) {
                    if (this.user.usuario.nmUsuario) {
                        return this.user.usuario.nmUsuario.split(" ")[0]
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }

            },
        },
        data: function () {
            return {
                routes: this.$router.options.routes.filter(x => x.meta != undefined && x.meta.authenticated == false),
                
                navegacao: "Chat",
                urlSite: urlSite, 

                utilizacoes: null,
                percentual: 0,
                txtPercentual: "",

                utilizacoesArtefato: null,
                percentualArtefato: 0,
                txtPercentualArtefato: "",


                utilizacoesResearch: null,
                percentualResearch: 0,
                txtPercentualResearch: "",

                msgManutencao: msgManutencao,
            }
        },
        methods: {
            subIsActive(input) {
                return this.nmComponente == input;
            },
            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Conversa/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                            if ($this.utilizacoes.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentual = parseInt(parseInt($this.utilizacoes.qtdRealizados) * 100 / parseInt($this.utilizacoes.qtdLiberados));
                                    this.txtPercentual = this.percentual + "%";
                                } catch {
                                    console.log("")
                                }
                                
                            } else {
                                this.percentual = 100;
                                this.txtPercentual = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },
            carregaUtilizacoesArtefatos() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoesArtefato = res.data.data;
                            if ($this.utilizacoesArtefato.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentualArtefato = parseInt(parseInt($this.utilizacoesArtefato.qtdRealizados) * 100 / parseInt($this.utilizacoesArtefato.qtdLiberados));
                                    this.txtPercentualArtefato = this.percentualArtefato + "%";
                                } catch {
                                    console.log("")
                                }

                            } else {
                                this.percentualArtefato = 100;
                                this.txtPercentualArtefato = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível a quantidade de artefatos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },
            carregaUtilizacoesResearchs() {
                let $this = this;
                axios.get(`${urlApi}/Research/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoesResearch = res.data.data;
                            if ($this.utilizacoesResearch.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentualResearch = parseInt(parseInt($this.utilizacoesResearch.qtdRealizados) * 100 / parseInt($this.utilizacoesResearch.qtdLiberados));
                                    this.txtPercentualResearch = this.percentualResearch + "%";
                                } catch {
                                    console.log("")
                                }

                            } else {
                                this.percentualResearch = 100;
                                this.txtPercentualResearch = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível a quantidade de researchs.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },

            load() {
                this.utilizacoes = null;
                this.percentual = 0;
                this.txtPercentual = "";

                this.utilizacoesArtefato= null;
                this.percentualArtefato = 0;
                this.txtPercentualArtefato = "";

                this.utilizacoesResearch = null;
                this.percentualResearch = 0;
                this.txtPercentualResearch = "";

                this.carregaUtilizacoes();
                this.carregaUtilizacoesArtefatos();
                this.carregaUtilizacoesResearchs();
            },
        },
        mounted: function () {
            this.load(); 
        },
        watch: {
            reload: function () {
                this.load(); 
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .active img {
        filter: brightness(0) invert(1);
    }
</style>

